export type Staleness = "live" | "delayed" | "stale";

/** Classify how fresh the last pane update is, by age in seconds. */
export function classifyAge(secondsSinceLastUpdate: number): Staleness {
  if (secondsSinceLastUpdate < 12) return "live"; // render cadence is ~5s
  if (secondsSinceLastUpdate < 30) return "delayed";
  return "stale";
}
